import {
  AfterViewInit, EventEmitter,
  Inject, Injectable,
  OnDestroy, OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DATA_TRANSFER_HELPER } from "../../helper/dataTransfer.helper";
import { TranslationDirective } from "../../app/shared-module/directives/translation.directive";
import { ResourceLanguage } from "../../models/resources/resources.model";

@Injectable()
export class SortService implements OnDestroy, AfterViewInit, OnInit {
  private $subscription: Subscription;
  private translationSubscription: Subscription;
  categoryTypes: {[key: string]: string}[];
  categoryPlaceHolder: string;
  static selectedCountries: string[] = [];
  static selectedLeadTypes: string[] = [];
  static selectedContactTypes: string[] = [];
  static selectedLeadPremiumProjectCustomerTypes: string[] = [];
  static selectedLeadStatuses: string[] = [];

  constructor(
    private router: Router,
    @Inject(DATA_TRANSFER_HELPER) private dataTransfer
  ) {
  }

  ngOnInit() {
    this.getCategoryNames();
  }

  ngAfterViewInit() {
  }

  getCategoryNames() {
    this.translationSubscription = TranslationDirective.getTranslations().subscribe(translations => {
      this.categoryTypes = [
        { categoryKey: '', categoryName: '-' },
        { categoryKey: 'Number', categoryName: translations['SEARCH_CATEGORY_LEAD_ID'] },
        { categoryKey: 'Documents', categoryName: translations['SEARCH_CATEGORY_DOCUMENT'] },
        { categoryKey: 'Address', categoryName: translations['SEARCH_CATEGORY_CONSTRUCTION_ADDRESS'] },
        { categoryKey: 'Contact', categoryName: translations['SEARCH_CATEGORY_CONTACT_DATA'] },
        { categoryKey: 'History', categoryName: translations['SEARCH_CATEGORY_NOTES'] },
        { categoryKey: 'EditorName', categoryName: translations['SEARCH_CATEGORY_RESPONSIBLE'] }
      ];
      this.categoryPlaceHolder = translations['SEARCH_CATEGORY'];
    });
  }

  ngOnDestroy(): void {
    this.translationSubscription?.unsubscribe();
    this.$subscription?.unsubscribe();
  }

  doSearch(searchText: string | string[], selectedCategoryKey: any, searchType: string = ''): void {
    if (!searchText && !selectedCategoryKey) {
      this.router.navigateByUrl('/');
    } else if (!Array.isArray(searchText) && searchText?.length > 0 && !selectedCategoryKey) {
      this.router.navigate(['/'], { queryParams: { q: searchText } });
    } else if (!Array.isArray(searchText) && searchText?.length > 0 && selectedCategoryKey) {
      this.router.navigate(['/'], { queryParams: { q: searchText, n: selectedCategoryKey } });
    } else if (Array.isArray(searchText) && selectedCategoryKey) {

      let queries
      let queryParams = {}
      if (searchType === 'commission') {
        queries = this.getQueriesForSorting(searchText?.join(','), 'commission');
        queryParams = { ...queries, n: selectedCategoryKey };
      }
      if (searchType === 'contact') {
        queries = this.getQueriesForSorting(searchText?.join(','), 'contact');
        queryParams = { ...queries, contact: searchText?.join(','), n: selectedCategoryKey };
      }
      if (searchType === 'responsible') {
        queries = this.getQueriesForSorting(searchText?.join(','), 'responsible');
        queryParams = { ...queries, responsible: searchText?.join(','), n: selectedCategoryKey };
      }

      this.router.navigate(['/'], { queryParams })
    } else if (selectedCategoryKey) {
      this.router.navigate(['/'], { queryParams: { n: selectedCategoryKey } });
    } else {
      this.router.navigateByUrl('/');
    }
  }

  getQueriesForSorting(newQueryData, key) {
    let queries = {
      commission: this.router.parseUrl(this.router.url).queryParamMap.get('commission'),
      contact: this.router.parseUrl(this.router.url).queryParamMap.get('contact'),
      responsible: this.router.parseUrl(this.router.url).queryParamMap.get('responsible')
    }

    queries[key] = newQueryData

    Object.entries(queries).map(([key, value]) => {
      if (!value) {
        delete queries[key];
      }
    })

    return queries
  }
}
